<template>
  <div class="new">
    <div class="container">
      <div>
        <h2>新闻动态</h2>
        <h3>News</h3>
      </div>
      <div class="main">
        <div class="left wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s" data-wow-offset="20">
          <div class="t">
            <img :src="newsFirst.title_pic" alt="">
          </div>
          <div class="b">
            <div>
              <h4 class="ellipsis">{{$AppLang == 'en' ? newsFirst.title_en : newsFirst.title}}</h4>
              <p class="ellipsis">{{$AppLang == 'en' ? newsFirst.subtitle_en : newsFirst.subtitle}}</p>
            </div>
          </div>
        </div>
        <div class="right">
          <ul>
            <li v-for="(newsItem,index) in newsList " :key="newsItem.id" class="wow fadeInRight" data-wow-duration="1s" data-wow-delay=".5s" data-wow-offset="20">
              <div class="l"><img :src="newsItem.title_pic" alt=""></div>
              <div class="r">
                <h4 class="ellipsis">{{$AppLang == 'en' ? newsItem.title_en : newsItem.title}}</h4>
                <p class="ellipsis">{{$AppLang == 'en' ? newsItem.subtitle_en : newsItem.subtitle}}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="more el-icon-right">
        <router-link to="/news">MORE</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'new',
  data() {
    return{
      list:[
        {id: 1,title: '企业新闻'},
        {id: 2,title: '行业新闻'},
        {id: 3,title: '查看更多'}
      ],
      newsFirst:{},
      newsList:[]
    };
  },
	mounted(){
// 		var that = this;
// 		var options={ live:false};
// 		that.$nextTick(function(){
// 			var wow=new that.$wow.WOW(options).init();
// 			console.log(1)
// 		})

	},
  created() {

    var that = this;
		var options={ live:false};
		that.$api.post2(
			'/news/homeNews',
			{},
			false,
			function(res) {
				if(res.data.rtnCode == 200){
					var list = res.data.data;
					if(list.length>0){
						that.newsFirst=list.shift();
						that.newsList = list;
					}
					that.$nextTick(function(){
						var wow=new that.$wow.WOW(options).init();
					});
				}else{
					alert(res.data.msg);
				}

			}
		);

  }
}
</script>

<style>
.new{
  background: #fff;
  padding: 50px 0;
}
.new h2,.new h3{
  margin: 0;
}
.new .main{
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 40px;
}
.new .main .left{
  width: 60%;
  box-sizing: border-box;
  padding-right: 20px;
  cursor: pointer;
}
.new .main .left .t{
  overflow: hidden;
  height: 350px;
}
.new .main .left .b{
  background: #f6f6f6;
  padding: 38px 0;
  box-sizing: border-box;
}
.new .main .left .b div{
  width: 500px;
  box-sizing: border-box;
  padding-left: 40px;
  position: relative;
  transition: all .3s ease;
}
.new .main .left .b div::before{
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 0;
  height: 1px;
  background: #333;
  transition: all .3s ease;
}
.new .main .left .b div h4{
  font-size: 16px;
  color: #6b6b6b;
  margin-bottom: 15px;
  width: 390px;
  height: 21px;
}
.new .main .left .b div p{
  font-size: 12px;
  color: #777;
  line-height: 20px;
  width: 390px;
  height: 40px;
}
.new .main .left:hover .b div{
  padding-left: 110px;
}
.new .main .right{
  width: 40%;
}
.new .main .left:hover .b div::before{
  width: 70px;
}
.new .main .right ul{
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.new .main .right ul li{
  padding: 20px;
  background: #eaeaea;
  display: flex;
  justify-content: space-between;
  transition: all .3s ease;
  cursor: pointer;
	height: 117px;
	box-sizing: border-box;
}
.new .main .right ul li .l{
  width: 30%;
  overflow: hidden;
}
.new .main .right ul li .l img{
  transition: all .3s ease;
}
.new .main .right ul li .r{
  width: 65%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  transition: all .3s ease;
}
.new .main .right ul li .r h4{
  font-size: 14px;
  color: #444;
  transition: all .3s ease;
}
.new .main .right ul li .r p{
  font-size: 12px;
  color: #828282;
  transition: all .3s ease;
}
.new .main .right ul li:hover{
  background: #333;
}
.new .main .right ul li:hover .l img{
  transform: scale(1.1);
}
.new .main .right ul li:hover .r{
  transform: translateX(-5px);
}
.new .main .right ul li:hover .r h4,.new .main .right ul li:hover .r p{
  color: #fff;
}
.new .more{
  width: 150px;
  margin: 0 auto;
  margin-top: 60px;
  border: 1px solid #9e9e9e;
  transition: all .3s linear;
  position: relative;
}
.new .more::before{
  color: #c7c7c7;
  transition: all .3s linear;
  opacity: 0;
  position: absolute;
  top: 50%;
  right: 30%;
  transform: translate(-50%,-50%);
}
.new .more:hover{
  background-color: #333;
}
.new .more:hover::before{
  opacity: 1;
  right: 20%;
}
.new .more:hover a{
  color: #fff;
  transform: translateX(-10px);
}
.new .more a{
  font-size: 14px;
  text-decoration: none;
  color: #666;
  display: block;
  padding: 12px  0;
  transition: all .3s linear;
}
@media (max-width: 992px){
  .new{
    padding: 50px 0;
  }
	.new .main {
		margin-top: 40px;
	}
  .new h2{
    font-size: 18px;
  }
  .new .main .left,.new .main .right{
    width: 100%;
  }
  .new .main .left{
    padding: 0;
  }
  .new .main .left .t{
    height: auto;
  }
	.new .main .left .b{
		padding: 38px 20px;
		margin-bottom: 30px;
	}
  .new .main .left .b div{
    width: 100%;
    padding: 0;
  }
  .new .main .left .b div h4,.new .main .left .b div p{
    width: 100%;
  }
	.new .main .right ul li{
		margin-bottom: 20px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/index/new.vue